import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's140g-s140m01',
    templateUrl: './s140g-s140m01.component.html'
})
export class S140gS140m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    zoneid: any = {'value': '____'};
    zndesc: any = {'value': '____________________________________________________________'};
    frlocn: any = {'value': '___'};
    tolocn: any = {'value': '___'};
    sbucd: any = {'value': '____'};
    msgln: any = {};
    updtkey: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'zoneid', 'zndesc', 'frlocn', 'tolocn', 'sbucd', 'msgln', 'updtkey'];
    public LINES: number[] = [1, 2, 3, 5, 6, 22, 8, 24, 10, 12, 14];

    ngAfterViewInit(): void {
    }
}
